import { createAsyncThunk } from '@reduxjs/toolkit';
import { getGuestCartTokenMagentoApiCall } from '../api/shop-cart.api';
import { MagentoGuestCartParams } from '../interfaces/magento-guest-cart-quote.interface';
import { GetShopCartParams } from '../interfaces/shop-cart.interface';
import { StoreState } from '../../../../store/store.interface';
import { ActionStatus } from '../../../../common/constants/action-status';

export const getGuestCartTokenMagento = createAsyncThunk(
  'shopCart/getCartToken',
  async ({}: MagentoGuestCartParams, thunkAPI) => {
    try {
      const token = await getGuestCartTokenMagentoApiCall();
      return token;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
  {
    condition: ({ forceUpdate = false }: GetShopCartParams, { getState }) => {
      const state = getState() as StoreState;
      if (
        !forceUpdate &&
        (state.shopCartState.getGuestCartTokenMagento.status == ActionStatus.loading ||
          state.shopCartState.getGuestCartTokenMagento.status == ActionStatus.succeeded)
      ) {
        return false;
      }
      return true;
    },
  }
);
